<style scoped>
    .search >>> .ivu-input{width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
    .approval >>> .ivu-btn{width: 160px;    border-radius: 36px;}
    .approval-list-tab{text-align: center;color: #333333;font-size: 14px;font-weight: bold;line-height: 62px;}/*border-bottom: 1px solid #d7dde4;*/
    .approval-list{text-align: center;color: #464c5b;font-size: 14px;line-height: 95px;}/*border-bottom: 1px solid #d7dde4;*/
    .approval-btn{height:36px;font-size: 14px;border-radius: 18px;margin: 0 5px;cursor: pointer;}
    .tab >>> .ivu-tabs-nav{line-height: 60px;margin-left:30px;}
    .tab >>>.ivu-tabs-tab{line-height: 60px;}
    .tab >>> .ivu-tabs-bar{margin-bottom: 0;}
    .notice-background{background: url("/img/sys/bg2.png");height: 140px;}
    .search >>> .ivu-input {width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
    .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
    .gradualChange{background:url('/img/systemSetup/gradualChange.png');background-repeat:no-repeat;width: 318px;height: 95px;display: inline-block;text-align: left;}
    .plateTrue{width: 238px;height: 108px;background-color: #fff;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
    .plateFalse{width: 238px;height: 108px;background-color: #f7f8ff;border-radius: 6px;display: flex;align-items: center;margin-top: 40px;}
    .eventName{font-size: 16px;display: inline-block;vertical-align: top;margin-left: 19px;}
    .eventFrame{width: 4px;height: 20px;background-color: #00a2e9;display: inline-block;border-radius: 2px;}
    .newlyBuild{width: 100px;height: 36px;line-height: 36px;color: #fff;font-size: 14px;box-shadow: 0px 0px 12px rgba(255,153,0,0.5);background-color: #ff9900;border-radius: 18px;    float: right;}
    .list{width: 722px;height: 108px;background-color: #f7f8ff;display: flex;align-items: center;border-radius: 6px;}
    .enable{margin-left:15px;color: #55c1f0;font-size: 14px;padding: 0 10px;border-radius: 11px;border: 1px solid #55c1f0;display: inline-block;line-height: 22px;}
    .button{margin-right:24px;background-color: #fff;font-size: 12px;color: #00a2e9;width: 80px;height: 30px;text-align: center;line-height: 30px;box-shadow: 0px 0px 12px rgba(45,140,240,0.1);border-radius: 15px;display: inline-block;}
</style>

<template>
  <div>
    <Modal
        v-model="commentPanel.state"
        ok-text="提交"
        title="请输入评论"
        @on-ok="addComment"
    >
      <Input v-model="commentPanel.content" :autosize="{ minRows:5, maxRows:10 }" type="textarea"></Input>
    </Modal>
    <Modal
        v-model="typePanel.state"
        :title="projectData.case_title+'的审批项'"
        width="1100"
    >
      <Row style="background-color: #fff;padding-bottom:40px">
        <i-col span="8" style="text-align: center;border-right: 1px solid #d7dde4">
          <div class="gradualChange">
            <img style="margin: 26px 10px 0 21px;vertical-align: top;" src="/img/project/fault-icon.png">
            <p style="color: #fff;font-size: 16px;display: inline-block;margin-top:24px;">审批类型</p>
          </div>
          <div style="background-color: #fff;width: 318px;display: inline-block;box-shadow: 0px 0px 12px rgba(0,0,0,0.1);text-align: center;margin-top: -24px;font-size: 0">
            <div style="display: inline-block;min-height:444px;">
              <div class="plateTrue" v-for="(item,index) in typeList.list">
                <div style="display: inline-block;cursor: pointer;text-align: left;"@click="modelList.search.key = item.id">
                  <div class="eventFrame" style="vertical-align: middle"></div>
                  <p class="eventName" style="color: #00a2e9;vertical-align: middle;line-height: 37px;">{{item.name}}</p>
                  <div style="color: #a8a8b2;font-size: 14px;margin-left: 19px;line-height: 37px">
                    <p style="display: inline-block;">创建时间：{{item.createTime}} </p>
                  </div>
                </div>
              </div>
            </div>
            <!--分页-->
            <div style="margin: 40px 0px 40px 40px;text-align: left;font-size: 12px">
              <Page
                  :page-size="typeList.search.pageSize"
                  :total="typeList.search.total"
                  @on-change="typeList.search.page = $event;getTypeList()"
              />
            </div>
          </div>
        </i-col>
        <i-col span="16" style="padding-left:15px;">
          <div style="height: 71px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;margin: 0 40px;">
            <div style="display: inline-block;">
              <img style="vertical-align: top;margin-right: 11px;" src="/img/project/template-icon.png"/>
              <p style="color: #434343;font-size: 16px;display: inline-block;">{{modelList.title}}</p>
            </div>
          </div>
          <!--列表-->
          <div style="min-height:445px;">
            <div style="display: flex;justify-content: center;margin-top: 40px;cursor: pointer" v-for="(item,index) in modelList.list" @click="state='submission';getModel(item,true)">
              <div class="list">
                <div style="display: inline-block;margin-left: 24px;line-height: 37px;">
                  <div>
                    <p style="font-size: 16px;color: #464c5b;display: inline-block;">{{item.name}}</p>
                    <div class="enable">已启用</div>
                  </div>
                  <!-- <div style="color: #a8a8b2;font-size: 14px;">
                    <p style="display: inline-block">创建人：{{item.creater}} </p>
                    <p style="display: inline-block">&nbsp;&nbsp; 时间：{{item.createTime}} </p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!--分页-->
          <div style="margin: 40px 0px 40px 40px;text-align: left;">
            <Page
                :page-size="modelList.search.pageSize"
                :total="modelList.search.total"
                @on-change="modelList.search.page = $event;getModelList()"
            />
          </div>
        </i-col>
      </Row>
    </Modal>
    <Modal
        @on-ok="createApproval()"
        v-model="modelPanel.state"
        :title="modelPanel.name+'['+projectData.case_title+']'"
        width="1000"
    >
      <Row>
        <Col span="12" v-for="(item,index) in approvalData">
          <component
              :key="'projectApproval'+modelPanel.id+index"
              v-if="item.display!='none'"
              :contentIn="item.content"
              style="margin: 10px auto;"
              :pattern="state"
              :index="index"
              :is="item.name"
              @change="$set(approvalData[index],'content',$event)"
              @del="approval.splice($event,1)"
          ></component>
        </Col>
        <Divider dashed  style="margin:15px"/>
        <template v-for="(item,index) in modelPanel.approvalPeo">
          <div style="margin-bottom:15px">
            <div style="display: inline-block;width:100px;text-align: right;vertical-align:middle;">审批人</div>：
            <div style="display: inline-block">{{item.UserName}}<span :style="item.State=='已审批'?'color:#19be6b':'color:red'">（{{item.State}}）<template v-if="item.ApprovalDealTime">[{{item.ApprovalDealTime}}]</template></span></div>
          </div>
        </template>
      </Row>
      <div slot="footer">
        <Button v-if="state=='submission'" type="primary" size="large" @click="createApproval">发起审批</Button>
        <template v-else>
          <Row v-for="(item,index) in modelPanel.comment" style="margin-bottom:10px">
            <Col span="4" style="text-align: right">{{item.UserName}}评论：</Col>
            <Col span="16" style="text-align: left">{{item.MessageContent}}<span style="color:#cecece">({{item.MessageCreated}} {{item.MessageCreatedTime}})</span></Col>
          </Row>
          <Button type="success" size="small" @click="exportExcel(approvalData,modelPanel.name,modelPanel.createTime)">导出</Button>
          <Button type="warning" size="small" @click="commentPanel.state = true">添加评论</Button>
          <Button type="text" size="large" @click="modelPanel.state = false">关闭</Button>
        </template>
      </div>
    </Modal>
    <Row style="background-color: white;border-bottom: 1px solid #d7dde4;height: 114px;position: relative;">
      <Col span="20" style="position: absolute;top: 50%;left: 0;transform: translate(0, -50%);">
        <div style="position: relative;">
          <Input class="search" placeholder="搜索项目名称/客户名称/主体名称"></Input>
          <div style="background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 4px;text-align: center;left: 310px;cursor:pointer;">
            <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
          </div>
        </div>
      </Col>
      <Col v-if="$route.query.filed!=1" span="3" class="approval" style="position: absolute;top: 50%;right: 20px;transform: translate(0, -50%);">
        <Button size="large" type="primary" shape="circle" @click="getTypeList()">发起审批</Button>
      </Col>
    </Row>
    <!--审批列表标签-->
    <Row class="approval-list-tab">
      <Col span="2">序号</Col>
      <Col span="6">审批类型</Col>
      <Col span="4">申请时间</Col>
      <Col span="4">申请人</Col>
      <Col span="4">状态</Col>
      <Col span="4">操作</Col>
    </Row>
    <!---->
    <Row class="approval-list" v-for="(item,index) in approvalList" :style="index%2==0?'background-color:#f8f8f9':''">
      <Col span="2">{{index+1}}</Col>
      <Col span="6">{{item.name}}</Col>
      <Col span="4">{{item.createTime}}</Col>
      <Col span="4">{{item.createPeople}}</Col>
      <Col span="4">{{item.state}}</Col>
      <Col span="4">
        <Button class="approval-btn" :type="item.stateId==0?'primary':''+item.stateId==1?'success':''+item.stateId==2?'error':''" @click="state = 'handle';getModel(item,false)">查看详情</Button>
        <Button class="approval-btn" type="error" v-if="item.stateId==0&&$route.query.filed!=1" style="background-color:rgb(247, 84, 84)" @click="deleteApproval(item.id)">撤回</Button>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="margin:40px 0 57px 0;">
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getApprovalList()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getApprovalList()"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
  import approvalCheckbox from '../../../components/setting/approval/approvalCheckbox'
  import approvalDate from '../../../components/setting/approval/approvalDate'
  import approvalDateRange from '../../../components/setting/approval/approvalDateRange'
  import approvalFile from '../../../components/setting/approval/approvalFile'
  import approvalFiles from '../../../components/setting/approval/approvalFiles'
  import approvalInput from '../../../components/setting/approval/approvalInput'
  import approvalRadio from '../../../components/setting/approval/approvalRadio'
  import approvalTextarea from '../../../components/setting/approval/approvalTextarea'
  import approvalTime from '../../../components/setting/approval/approvalTime'
  import approvalTimeRange from '../../../components/setting/approval/approvalTimeRange'
  import approvalExplain from '../../../components/setting/approval/approvalExplain'
  export default {
    name: "approval",//审批
    props:['projectData'],
    data:function () {
      return{
        state:'handle',//submission
        content:{},
        typePanel:{
          state:false,
          search:{
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
        commentPanel:{
          state:false,
          content:'',
        },
        payTypeList:[],
        client:[],
        opposed:[],
        modelListPanel:{
          state:false,
          search:{
            pageSize: 5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
        modelPanel:{
          state:false,
          title:'',
          id:'',
          comment:[],
        },
        userList:[],
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        approvalData:[],
        approvalList:[],
        typeList:{
          editType:{
            panel:false,
            name:'',
            id:'',
          },
          search:{
            pageSize: 3,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
          list:[],
          switch1:false,
        },
        modelList:{
          title:'',
          list:[],
          switch1:false,
          search:{
            key:'',
            pageSize:5,//每页显示多少条
            total: 0,//总条数
            page: 1,//当前页
            text:'',//搜索文字
          },
        },
      }
    },
    components:{
      approvalCheckbox:approvalCheckbox,
      approvalDate:approvalDate,
      approvalDateRange:approvalDateRange,
      approvalFile:approvalFile,
      approvalFiles:approvalFiles,
      approvalInput:approvalInput,
      approvalRadio:approvalRadio,
      approvalTextarea: approvalTextarea,
      approvalTime: approvalTime,
      approvalTimeRange: approvalTimeRange,
      approvalExplain: approvalExplain,
    },
    mounted:function(){
      this.getApprovalList()
      this.getPayType()
      this.projectRegister()
      this.getUserList()
      this.getLitigationList()
    },
    watch:{
      'modelList.search.key':function () {
        this.modelList.search.page = 1
        this.getModelList()
      }
    },
		computed:{
			companyName:function(){
				return companyName
			},
		},
    methods:{
      addComment:function(){
        var _this = this
        _this.send({
          headers:"L/AddApprovalMessage",
          data:{
            ApprovalId:_this.modelPanel.id,
            MessageContent:_this.commentPanel.content,
          },
          success:function () {
            _this.commentPanel.state = false
            _this.modelPanel.state = false
            _this.modelPanel.content = ''
            _this.$Notice.success({
              title:'系统消息',
              desc:'评论添加成功！'
            })
            _this.getApprovalList()
          }
        })
      },
      deleteApproval:function(id){
        var _this = this
        _this.send({
          headers:"L/DeleteApproval",
          confirm:true,
          data:{
            ApprovalId:id
          },
          success:function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'审批撤回成功！'
            })
            _this.getApprovalList()
          }
        })
      },
      getTypeList:function () {
        var _this = this
        _this.typeList.list = []
        _this.send({
          headers:'C/ShowApprovalType',
          data:{
            page : _this.typeList.search.page,
            pageSize : _this.typeList.search.pageSize,
            key : _this.typeList.search.text,
            ApprovalDefault:1,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.typeList.list,i,{})
              _this.$set(_this.typeList.list[i],'id',res.List[index].ApprovalTypeId)
              _this.$set(_this.typeList.list[i],'name',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.typeList.list[i],'createTime',res.List[index].ApprovalTypeCreatedTime)
              i++
            }
            _this.typeList.search.total=res.Count
            if(_this.modelList.search.key==''){
              _this.modelList.search.key = _this.typeList.list[0].id
              _this.modelList.title = _this.typeList.list[0].name
            }
            _this.typePanel.state = true
          }
        })
      },
      getModelList:function () {
        var _this = this
        _this.modelList.list = []
        _this.send({
          headers:'L/ShowApprovalMode',
          data:{
            ApprovalTypeId:_this.modelList.search.key,
            page : _this.modelList.search.page,
            pageSize : _this.modelList.search.pageSize,
            key : _this.modelList.search.text,
          },
          success:function (res) {
            var i = 0
            for(var index in res.List){
              _this.$set(_this.modelList.list,i,{})
              _this.$set(_this.modelList.list[i],'id',res.List[index].ApprovalId)
              _this.$set(_this.modelList.list[i],'name',res.List[index].ApprovalModeTitle)
              _this.$set(_this.modelList.list[i],'data',res.List[index].ApprovalModeContent)
              _this.$set(_this.modelList.list[i],'creater',res.List[index].UserName)
              _this.$set(_this.modelList.list[i],'typeName',res.List[index].ApprovalTypeTitle)
              _this.$set(_this.modelList.list[i],'createTime',res.List[index].ApprovalModeCreatedTime)
              _this.$set(_this.modelList.list[i],'editTime',res.List[index].ApprovalModeUpdateTime)
              _this.$set(_this.modelList.list[i],'modelId',res.List[index].ApprovalModeId)
              if(Boolean(res.List[index].ApprovalAssessorId)){
                _this.$set(_this.modelList.list[i],'approverList',res.List[index].ApprovalAssessorId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'approverList','')
              }
              if(Boolean(res.List[index].ApprovalCopyId)){
                _this.$set(_this.modelList.list[i],'copyList',res.List[index].ApprovalCopyId.split(','))
              }else{
                _this.$set(_this.modelList.list[i],'copyList','')
              }
              i++
            }

            _this.modelList.search.total=res.Count
          }
        })
      },
      //获取当事人列表
      getLitigationList:function(){
        var _this = this
        _this.client = []
        _this.opposed = []
        _this.send({
          headers:'E/LitigatsList',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            for(var index in res){
              if(res[index].LitigationStatusId==1){
                _this.client.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
              if(res[index].LitigationStatusId==2){
                _this.opposed.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
            }
          }
        })
      },
      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
          }
        })
      },
      createApproval:function(){
        var _this = this
        for(var i = 0;i < _this.approvalData.length;i++){
          if(_this.approvalData[i].content.allowSubmission==false){
            return _this.$Modal.error({
              title:'系统提示',
              content:'请完成所有必填项再进行提交！',
            })
          }
        }
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        for(var i=0;i<_this.client.length;i++){
          tempClientName.push(_this.client[i].name,)
          tempClientAddress.push(_this.client[i].address,)
        }
        for(var i=0;i<this.opposed.length;i++){
          tempOpposedName.push(this.opposed[i].name)
        }
        var tempManageName = []
        for(var i=0;i<_this.content.manager;i++){
          if(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]})){
            tempManageName.push(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]}).name)
          }
        }
        var approval = _this.approvalData
          // if(_this.modelPanel.id!='1'&&_this.modelPanel.modelId!='2'&&_this.modelPanel.modelId!='3'){
          //   approval.splice(0,0,{"name":"approvalInput","content":{"title":"申请人","text":window.sessionStorage.fullName}},)
          //   approval.splice(1,0,{"name":"approvalInput","content":{"title":"主办律师","text":tempManageName.toString()}},)
          //   approval.splice(2,0,{"name":"approvalInput","content":{"title":"案号","text":_this.content.caseNumber}},)
          //   approval.splice(3,0,{"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},)
          //   approval.splice(4,0,{"name":"approvalInput","content":{"title":"委托人","text":tempClientName.toString()}},)
          //   approval.splice(5,0,{"name":"approvalInput","content":{"title":"被告人","text":tempOpposedName.toString()}},)
          // }
        // approval = [
        //   {"name":"approvalInput","content":{"title":"申请人","text":tempClientName.toString()}},
        //   {"name":"approvalInput","content":{"title":"住所","text":tempClientAddress[0]}},
        //   {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName}},
        //   {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile}},
        //   {"name":"approvalInput","content":{"title":"对方当事人","text":tempOpposedName.toString()}},
        //   // {"name":"approvalInput","content":{"title":"第三人","text":null}},
        //   {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},
        //   {"name":"approvalInput","content":{"title":"委托人","text":tempClientName}},
        //   {"name":"approvalInput","content":{"title":"主办律师","text":tempManageName.toString()}},
        //   {"name":"approvalInput","content":{"title":"受理机关","text":_this.content.receivingUnitText}},
        //   {"name":"approvalInput","content":{"title":"审级或阶段","text":_this.content.caseStage}},
        //   {"name":"approvalInput","content":{"title":"争议标的额","text":_this.content.casetAmount}},
        //   {"name":"approvalInput","content":{"title":"收费比例/金额","text":_this.content.projectAmount}},
        //   {"name":"approvalInput","content":{"title":"收费方式","text":_this.payTypeList.find((secItem)=>{return secItem.id==_this.content.payType}).name}},
        //   {"name":"approvalInput","content":{"title":"结算方式","text":_this.content.settlementMethod}},
        //   {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails}}
        // ]
				var sendData = {
					ApprovalModeId:_this.modelPanel.modelId,
					CaseId:_this.$route.query.caseId,
					ApprovalContent:approval,
				}
				if(companyName=='刚峰'){
					if(_this.modelPanel.modelId==1||_this.modelPanel.modelId==2||_this.modelPanel.modelId==3){
						sendData.ExcessAssessors = _this.content.manager.toString()
					}
				}
        _this.send({
          headers:'L/AddApproval',
          data:sendData,
          success:function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'发起审批成功！'
            })
            _this.modelPanel.state = false
          }
        })
        _this.getApprovalList()
      },
      getComment:function(item){
        var _this = this
        _this.modelPanel.comment = []
        _this.send({
          headers:"L/ApprovalMessage",
          data:{
            ApprovalId:item.id
          },
          success:function (res) {
            _this.modelPanel.comment = res
          }
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.content.name=res.case_title
            _this.content.caseNumber=res.case_num
            _this.content.caseAmount=res.case_subject_matter
            _this.content.projectAmount=res.case_pay_count
            _this.content.casetAmount=res.case_subject_matter
            _this.content.caseStage=res.case_stage
            _this.content.caseDetails=res.case_situation
            _this.content.contactName=res.case_linkman
            _this.content.contactMobile=res.case_linkman_tel
            _this.content.createDate=res.case_create_time
            _this.content.caseTypeId=res.case_type_id
            // _this.content.receivingUnitText=res.case_type_id
            _this.content.payType=parseInt(res.case_charge_id)
            _this.content.receivingUnit=parseInt(res.case_acceptance_id)
            _this.content.causeTypeSelected=res.case_action_id//案由ID
            _this.content.cause=res.case_action_info//案由
            _this.content.modelTypeSelected=res.case_action_second_id//细分模板ID
            _this.content.modelSelected=res.case_action_detail_id//模板ID
            _this.content.source=res.case_from_id?res.case_from_id.split(','):[]
            _this.content.manager=res.case_executor_id?res.case_executor_id.split(','):[]
            _this.content.otherUser=res.case_member_id?res.case_member_id.split(','):[]
          }
        })
      },
      getApprovalList: function () {
        var _this = this
        _this.approvalList = []
        _this.send({
          headers: "L/CaseApproval",
          data: {
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
            CaseId:_this.$route.query.caseId,
          },
          success: function (res) {
            for(var index in res.list){
              _this.approvalList.push({
                name:res.list[index].ApprovalModeTitle,
                createTime:res.list[index].ApprovalCreatedTime,
                createPeople:res.list[index].UserName,
                state:res.list[index].ApprovalResultsTitle,
                stateId:res.list[index].ApprovalResultsId,
                data:res.list[index].ApprovalContent,
                id:res.list[index].ApprovalId,
                approvalPeo:res.list[index].ApprovalAssessorsArr,
                modelId:res.list[index].ApprovalModeId
              })
            }
            _this.search.total=res.count
          }
        })
      },
      //获取收费方式
      getPayType:function(){
        var _this = this
        _this.payTypeList = []
        _this.send({
          headers:'C/CaseChargeList',
          success:function (res) {
            for(var index in res){
              _this.payTypeList.push({
                id:res[index].CaseChargeId,
                name:res[index].CaseChargeTitle,
              })
            }
          }
        })
      },
      getModel:function (itemIn,setData) {
        var _this = this
        var item = JSON.parse(JSON.stringify(itemIn))
        if(_this.state!='submission'){
          _this.getComment(item)
        }
        _this.approvalData = []
        // var tempClientName = []
        // var tempClientAddress = []
        // var tempOpposedName = []
        // for(var i=0;i<_this.client.length;i++){
        //   tempClientName.push(_this.client[i].name)
        // }
        // for(var i=0;i<this.opposed.length;i++){
        //   tempOpposedName.push(this.opposed[i].name)
        // }
        // var tempManageName = []
        // for(var i=0;i<_this.content.manager;i++){
        //   if(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]})){
        //     tempManageName.push(_this.userList.find((secItem)=>{return secItem.id==_this.content.manager[i]}).name)
        //   }
        // }
        // var approvalTemp = []
        // if(item.modelId=='1'&&setData==false){
        //   approvalTemp = [
        //     {"name":"approvalInput","content":{"title":"委托名称","text":tempClientName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"住所","text":''||''}},
        //     {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName||''}},
        //     {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile||''}},
        //     {"name":"approvalInput","content":{"title":"对方当事人","text":tempOpposedName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"第三人","text":''}},
        //     {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause||''}},
        //     {"name":"approvalInput","content":{"title":"承办律师","text":tempManageName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"受理机关","text":''}},
        //     {"name":"approvalInput","content":{"title":"审级或阶段","text":_this.content.caseStage||''}},
        //     {"name":"approvalInput","content":{"title":"争议标的额","text":_this.content.casetAmount||''}},
        //     {"name":"approvalInput","content":{"title":"收费比例/金额","text":_this.content.projectAmount||''}},
        //     {"name":"approvalInput","content":{"title":"收费方式","text":''}},
        //     {"name":"approvalInput","content":{"title":"结算方式","text":''}},
        //     {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails||''}},
        //     {"name":"approvalFile","content":{"title":"盖章文件","fileName":"","filesSrc":"","seal":"1"},"display":"none",}
        //   ]
        //   for(var i=0;i<approvalTemp.length;i++){
        //     _this.approvalData.push(approvalTemp[i])
        //   }
        // }else if(item.modelId=='2'&&setData==false){
        //   approvalTemp = [
        //     {"name":"approvalInput","content":{"title":"委托名称","text":tempClientName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"住所","text":''}},
        //     {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName||''}},
        //     {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile||''}},
        //     {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause||''}},
        //     {"name":"approvalInput","content":{"title":"承办律师","text":tempManageName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"受理机关","text":''}},
        //     {"name":"approvalInput","content":{"title":"审级或阶段","text":_this.content.caseStage||''}},
        //     {"name":"approvalInput","content":{"title":"收费比例/金额","text":_this.content.projectAmount||''}},
        //     {"name":"approvalInput","content":{"title":"结算方式","text":''}},
        //     {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails||''}},
        //     {"name":"approvalFile","content":{"title":"盖章文件","fileName":"","filesSrc":"","seal":"1"},"display":"none",}
        //   ]
        //   _this.approvalData = approvalTemp
        // }else if(item.modelId=='3'&&setData==false){
        //   approvalTemp = [
        //     {"name":"approvalInput","content":{"title":"委托名称","text":tempClientName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"地址","text":''}},
        //     {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName||''}},
        //     {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile||''}},
        //     {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause||''}},
        //     {"name":"approvalInput","content":{"title":"承办律师","text":tempManageName.toString()||''}},
        //     {"name":"approvalInput","content":{"title":"收费数额","text":_this.content.projectAmount||''}},
        //     {"name":"approvalInput","content":{"title":"结算方式","text":''}},
        //     {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails||''}},
        //     {"name":"approvalFile","content":{"title":"盖章文件","fileName":"","filesSrc":"","seal":"1"},"display":"none",},
        //   ]
        //   _this.approvalData = approvalTemp
        // if(setData==true){
        //   this.approvalData = item.data
          // this.approvalData.splice(0,0,{"name":"approvalInput","content":{"title":"申请人","text":window.sessionStorage.fullName}},)
          // this.approvalData.splice(1,0,{"name":"approvalInput","content":{"title":"主办律师","text":tempManageName.toString()}},)
          // // this.approvalData.splice(2,0,{"name":"approvalInput","content":{"title":"案号","text":_this.content.caseNumber}},)
          // this.approvalData.splice(3,0,{"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},)
          // this.approvalData.splice(4,0,{"name":"approvalInput","content":{"title":"委托人","text":tempClientName.toString()}},)
          // this.approvalData.splice(5,0,{"name":"approvalInput","content":{"title":"被告人","text":tempOpposedName.toString()}},)
        // }else if(setData == false){
        //   this.approvalData = item.data
        // }
        this.approvalData = item.data
        this.modelPanel.name = item.name
        this.modelPanel.id = item.id||item.modelId
        this.modelPanel.modelId = item.modelId
        this.modelPanel.createTime = item.createTime
        this.modelPanel.approvalPeo = item.approvalPeo
        this.modelPanel.state = true
        this.modelListPanel.state = false
      }
    },
  }
</script>

